import React from 'react'

/**
 * AgendaPlaceholder — Option B stub for the Agenda section.
 *
 * The Agenda tree was deleted in commit 38ce2a8 and is a follow-up rebuild.
 * This placeholder preserves the section's position in the canvas order
 * without blocking the consolidation.
 */
export function AgendaPlaceholder() {
  return (
    <div className="agenda-placeholder empty-big" data-testid="agenda-placeholder">
      <p className="empty-big__text">
        Agenda — coming in a future update.
      </p>
    </div>
  )
}
